import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";

const useStyles = makeStyles(theme => ({
  root: {
    display: "flex",
    flexWrap: "wrap"
  },
  formControl: {
    margin: theme.spacing(1),
    width: "100%"
  },
  inputLabel: {
    fontSize: "1vw"
  },
  selectEmpty: {
    marginTop: theme.spacing(2)
  }
}));

export default function SimpleSelect(props) {
  const classes = useStyles();

  const [label, setLabel] = React.useState(props.product.description);
  const [value, setValue] = React.useState(props.product.id);
  const [positionToReplace, setPositionToReplace] = React.useState(props.position);

  function handleChange(event) {
    //llamar a la funcion de actualizar el
    props.updtProducts(event.target.value,positionToReplace);

    var indexOfAternativeProduct = props.products.findIndex(i => i.alternativeProduct.id === event.target.value);

    setLabel(props.products[indexOfAternativeProduct].alternativeProduct.description);
    setValue(props.products[indexOfAternativeProduct].alternativeProduct.id);
  }

  return (
    <FormControl className={classes.formControl}>
      <InputLabel className={classes.inputLabel} htmlFor="alt-options">{label}</InputLabel>
      <Select
        value={value}
        onChange={handleChange}
      >
        {props.products.map(prod => (
          <MenuItem key={prod.alternativeProduct.id} value={prod.alternativeProduct.id}>{prod.alternativeProduct.description}</MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
